import isValidDate from './validators/date';

export const calculateAge = (birthdate?: Date): number => {
  if (!birthdate) return 0;
  const today = new Date();
  let age = today.getFullYear() - birthdate.getFullYear();
  const monthDiff = today.getMonth() - birthdate.getMonth();
  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthdate.getDate())
  ) {
    age -= 1;
  }
  return age;
};

const MIN_AGE = 18;

export const isBirthdateValid = (birthdate?: Date) => isValidDate(birthdate);
export const meetsAgeRequirement = (birthdate?: Date) =>
  isBirthdateValid(birthdate) && calculateAge(birthdate) >= MIN_AGE;

export default calculateAge;
